import { Bem, addClass } from '../../../utils/css.js';
import 'react';
import { warnOnce } from '../../../utils/common.js';

const bem = Bem.create("vai-form-item");
function decorateLabelProps({
  labelProps,
  labelWidth,
  disabled: itemDisabled
}) {
  const { disabled = !!itemDisabled, width = labelWidth, className, ...rest } = labelProps;
  return {
    disabled,
    width,
    className: addClass(bem.element("label")(), className),
    ...rest
  };
}
function decorateRequiredAsteriskProps({
  required,
  requiredAsteriskProps = {}
}) {
  const { hidden = !required, className, ...rest } = requiredAsteriskProps;
  return {
    className: addClass(bem.element("required-asterisk")(), className),
    hidden,
    ...rest
  };
}
const nonGenericProps = [
  "label",
  "component",
  "info",
  "dataTa",
  "htmlId",
  "suppressErrors",
  "required",
  "disabled",
  "requiredAsteriskProps",
  "componentMetaProperties",
  "errors",
  "componentProps",
  "labelProps",
  "labelWidth",
  "itemErrors"
];
function reduceComponentProps(props) {
  let partialProps = nonGenericProps.reduce((obj, key) => {
    const { [key]: removed, ...rest } = obj;
    return rest;
  }, props);
  const metaProperties = props.component ? props.component?.metaProperties : null;
  const { suppressErrors, componentProps = {}, componentMetaProperties = metaProperties } = props;
  const hasMeta = (prop) => (componentMetaProperties || []).includes(prop) && componentProps[prop] === void 0;
  if (hasMeta("invalid")) {
    partialProps.invalid = !suppressErrors && props.errors ? !!props.errors : false;
  }
  if (hasMeta("required")) {
    partialProps.required = !!props.required;
  }
  if (hasMeta("disabled")) {
    partialProps.disabled = !!props.disabled;
  }
  if (props.component && !componentMetaProperties) {
    warnOnce(`FormItems component ${props.component?.displayName} did not have static 'metaProperties' descriptor variable defined.
        
To ensure that (boolean) meta properties 'disabled', 'required' and 'invalid' are passed properly to your component, 
the component should have define an static list of meta* properties (metaProperties) that the component accepts.
If this 'metaProperties' is not defined, these meta properties are not passed to component.

Optionally use FormItems property 'componentMetaProperties' to circumvent components metaProperties.`);
  }
  return { ...componentProps, ...partialProps };
}

export { bem, decorateLabelProps, decorateRequiredAsteriskProps, reduceComponentProps };
